import { api } from "@/lib/api";
import { ApiResponse, Currency } from "@/lib/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetCurrencies = (
  options?: Omit<
    UseQueryOptions<ApiResponse<Currency[]>>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery<ApiResponse<Currency[]>>({
    queryKey: ["currencies"],
    queryFn: async () => {
      const response = await api.get("/currencies");
      return response.data;
    },
    ...options,
  });
};

export const useGetCurrencyById = (
  id?: string,
  options?: Omit<UseQueryOptions<ApiResponse<Currency>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Currency>>({
    queryKey: ["currency-detail", id],
    queryFn: async () => {
      const response = await api.get(`/currencies/${id}`);
      return response.data;
    },
    enabled: !!id,
    ...options,
  });
};
